import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

import { LazyComponentId } from 'src/app/core/services/lazy-components/lazy-components-registry';
import { ModalService } from 'src/app/shared/modal/modal-service/modal.service';
import { Data } from 'src/app/utils/models/data.interface';

@Directive({
  selector: '[ccModalLink]',
  standalone: true
})
export class ModalLinkDirective implements OnInit {
  private modalComponent?: LazyComponentId;
  private requestData: Data = {};

  private readonly enterKey = 'Enter';
  private readonly spaceKey = 'Space';

  public constructor(
    private readonly elementRef: ElementRef<HTMLLinkElement>,
    private readonly modalService: ModalService
  ) {}

  @Input('ccModalLink')
  public set value(value: LazyComponentId | [LazyComponentId, Data] | null) {
    if (value === null) {
      // when the value is null on purpose, the directive should not do anything
      return;
    }
    if (typeof value === 'string') {
      this.modalComponent = value;
      return;
    } else if (Array.isArray(value) && value.length > 0) {
      const [componentId, data] = value;
      this.modalComponent = componentId;
      if (data) this.requestData = data;
      return;
    }
    throw new Error('invalid value for ccModalLink directive');
  }

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {
    event.preventDefault();
    this.openModal();
  }

  @HostListener('keydown', ['$event'])
  public onKeydownHandler(event: KeyboardEvent): void {
    if (event.code === this.enterKey || event.code === this.spaceKey) {
      event.preventDefault();
      this.openModal();
    }
  }

  public ngOnInit(): void {
    if (this.elementRef.nativeElement.tagName === 'A') {
      this.elementRef.nativeElement.href = '#';
    }
  }

  private openModal(): void {
    if (this.modalComponent) {
      this.modalService.open(this.modalComponent, this.requestData);
    }
  }
}
